module.exports = __webpack_public_path__ + "img/expand.51aa5801.svg";